import {CommonModule}                                              from '@angular/common';
import {booleanAttribute, Component, ElementRef, input, ViewChild} from '@angular/core';
import {ChartConfiguration}                                        from 'chart.js';
import {ChartCompBase}                                             from '../../tools/chart-comp.base';


@Component({
			   selector   : 'lib-chart-scatter',
			   imports    : [CommonModule],
			   templateUrl: './chart-scatter.component.html',
			   styleUrl: './chart-scatter.component.css'
		   })
export class ChartScatterComponent extends ChartCompBase<'scatter' | 'line', any> {
	@ViewChild('ChartItem') chartItem!: ElementRef<HTMLCanvasElement>;
	@ViewChild('LegendWrapper') legendWrapper!: ElementRef<HTMLDivElement>;
	chartConf = input.required<ChartConfiguration<'scatter' | 'line'>>();
	disableLegend = input(booleanAttribute(false), {transform: booleanAttribute});
}
